import axios from "../utils/axios";

// ==========================================
// Coupons
// ==========================================

export const getCoupons = async (params) => {
    const response = await axios.get("/admin/coupons", { params });
    return response.data;
};

export const getCouponById = async (id) => {
    const response = await axios.get(`/admin/coupons/${id}`);
    return response.data;
};

export const createCoupon = async (data) => {
    const response = await axios.post("/admin/coupons", data);
    return response.data;
};

export const updateCoupon = async (id, data) => {
    const response = await axios.put(`/admin/coupons/${id}`, data);
    return response.data;
};

export const deleteCoupon = async (id) => {
    const response = await axios.delete(`/admin/coupons/${id}`);
    return response.data;
};
